import React from 'react';
import { motion } from 'framer-motion';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const FilterPanel = ({ 
  selectedCategory, 
  onCategoryChange, 
  selectedTech, 
  onTechChange, 
  sortBy, 
  onSortChange,
  onReset 
}) => {
  const categories = [
    { value: 'all', label: 'All Projects', icon: 'Grid3x3' },
    { value: 'tech', label: 'Tech Projects', icon: 'Code2' },
    { value: 'business', label: 'Business', icon: 'Briefcase' },
    { value: 'creative', label: 'Creative', icon: 'Palette' }
  ];

  const technologies = [
    'React', 'Node.js', 'Python', 'TypeScript', 'MongoDB', 
    'AWS', 'Docker', 'GraphQL', 'Next.js', 'Vue.js'
  ];

  const sortOptions = [
    { value: 'recent', label: 'Most Recent', icon: 'Clock' },
    { value: 'popular', label: 'Most Popular', icon: 'TrendingUp' },
    { value: 'alphabetical', label: 'A-Z', icon: 'ArrowDownAZ' }
  ];

  return (
    <motion.div
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      className="bg-card rounded-xl p-4 md:p-6 border border-border shadow-md mb-6 md:mb-8"
    >
      <div className="flex items-center justify-between mb-4 md:mb-6">
        <h3 className="text-lg md:text-xl font-semibold flex items-center gap-2">
          <Icon name="Filter" size={24} color="var(--color-primary)" />
          Filter Projects
        </h3>
        <Button
          variant="ghost"
          size="sm"
          onClick={onReset}
          iconName="RotateCcw"
          iconPosition="left"
        >
          Reset
        </Button>
      </div>
      <div className="space-y-4 md:space-y-6">
        <div>
          <label className="block text-sm font-medium mb-3">Category</label>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-2 md:gap-3">
            {categories?.map((category) => (
              <motion.button
                key={category?.value}
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
                onClick={() => onCategoryChange(category?.value)}
                className={`p-3 rounded-lg border transition-all duration-300 flex flex-col items-center gap-2 ${
                  selectedCategory === category?.value
                    ? 'bg-primary text-primary-foreground border-primary'
                    : 'bg-muted border-border hover:border-primary'
                }`}
              >
                <Icon 
                  name={category?.icon} 
                  size={20} 
                  color={selectedCategory === category?.value ? 'white' : 'currentColor'} 
                />
                <span className="text-xs md:text-sm font-medium">{category?.label}</span>
              </motion.button>
            ))}
          </div>
        </div>

        <div>
          <label className="block text-sm font-medium mb-3">Technology Stack</label>
          <div className="flex flex-wrap gap-2">
            {technologies?.map((tech) => (
              <motion.button
                key={tech}
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                onClick={() => onTechChange(tech)}
                className={`px-3 py-1.5 rounded-full text-xs md:text-sm font-medium transition-all duration-300 ${
                  selectedTech?.includes(tech)
                    ? 'bg-secondary text-secondary-foreground'
                    : 'bg-muted text-foreground hover:bg-muted/80'
                }`}
              >
                {tech}
              </motion.button>
            ))}
          </div>
        </div>

        <div>
          <label className="block text-sm font-medium mb-3">Sort By</label>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-2 md:gap-3">
            {sortOptions?.map((option) => (
              <motion.button
                key={option?.value}
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
                onClick={() => onSortChange(option?.value)}
                className={`p-3 rounded-lg border transition-all duration-300 flex items-center gap-2 justify-center ${
                  sortBy === option?.value
                    ? 'bg-accent text-accent-foreground border-accent'
                    : 'bg-muted border-border hover:border-accent'
                }`}
              >
                <Icon 
                  name={option?.icon} 
                  size={18} 
                  color={sortBy === option?.value ? 'var(--color-accent-foreground)' : 'currentColor'} 
                />
                <span className="text-sm font-medium">{option?.label}</span>
              </motion.button>
            ))}
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default FilterPanel;